var analyticResults = [];

$('#startOrder-btn').on('click', function (e) {
    setTimeout(() => {
        applyDancingBubble(e, 'white');
    })
    orderViewModel.flushCart();
    var btnTxt = $('#startOrder-btn').text();
    btnTxt = btnTxt ? btnTxt.toLowerCase() : btnTxt;
    if($(this).hasClass('continue')) {
        handleCtaClickAnalytics(btnTxt);
        setTimeout(function () { window.location.href = e.target.dataset.url; }, 1000);
        return;
    }
    $('#reOrderModal').hide();
    
    if (orderViewModel.orderType === 'delivery') {
        orderViewModel.store.id = orderViewModel.store.id;
        orderViewModel.save();
    } else {
        orderViewModel.store.id = subwayScript.getStoreId(orderViewModel.storeData.LocationId.StoreNumber, orderViewModel.storeData.LocationId.SatelliteNumber);
        orderViewModel.store.StoreId = subwayScript.getStoreId(orderViewModel.storeData.LocationId.StoreNumber, orderViewModel.storeData.LocationId.SatelliteNumber);
        orderViewModel.save();
    }
    analytics.removeMaintainCart(analyticResults, true, btnTxt);
    setTimeout(function () { window.location.href = subwayScript.navigation.getMenuUrl(orderViewModel.store.id); }, 1000);


});

$('#removeItem-btn').on('click', function (e) {
    applyDancingBubble(e, 'white');
    var btnTxt = $('#removeItem-btn').text().toLowerCase();
    var currentLocationId = orderViewModel.storeData ? subwayScript.getStoreId(orderViewModel.storeData.LocationId.StoreNumber, orderViewModel.storeData.LocationId.SatelliteNumber) : null;
    var request = {
        LocationId: currentLocationId,
        FulfillmentType: orderViewModel.orderType,
        CartId: orderViewModel.currentOrder.cartId,
        ItemUnavailableList: orderViewModel.ItemUnavailableList,
        CartItemId: orderViewModel.cartItemId ? orderViewModel.cartItemId : null,
        BundleItemId : orderViewModel.bundleItemId ? orderViewModel.bundleItemId : null
    };
    if (orderViewModel.orderType === 'delivery') {
        request.LocationId = orderViewModel.store.id;
        request.StreetAddressLine1 = orderViewModel.DeliveryAddress.StreetAddressLine1;
        request.StreetAddressLine2 = orderViewModel.DeliveryAddress.StreetAddressLine2;
        request.City = orderViewModel.DeliveryAddress.City;
        request.State = orderViewModel.DeliveryAddress.State;
        request.Zip = orderViewModel.DeliveryAddress.Zip;
        request.Country = orderViewModel.DeliveryAddress.Country;
        request.DirectDelivery = orderViewModel.DeliveryAddress.DirectDelivery;
        request.QuoteId = orderViewModel.DeliveryAddress.QuoteId;
    }
    $.ajax({
        url: '/RemoteOrder/Orders/RemoveAndContinueMaintainCart',
        type: 'POST',
        cache: false,
        async: false,
        headers: { "cache-control": "no-cache" },
        data: request,
        error: function (jqXhr) {
            subwayScript.showAjaxError(jqXhr);
        },
        success: function (resultData) {
            let avaialbeItems = analyticResults.filter((item) => (item.productUnavialable || item.itemAvailable))
            if (avaialbeItems.length > 0) {
                analytics.removeMaintainCart(avaialbeItems, false, btnTxt);
            } else {
                analytics.removeMaintainCart([], false, btnTxt);
            }
            if (orderViewModel.orderType === 'delivery') {
                orderViewModel.store.StoreId = subwayScript.checkSatelliteNumber(orderViewModel.store.id);
                orderViewModel.store.address = orderViewModel.DeliveryAddress.StreetAddressLine1;
                orderViewModel.store.address1 = orderViewModel.DeliveryAddress.StreetAddressLine1;
                orderViewModel.store.address3 = null;
                orderViewModel.store.city = orderViewModel.DeliveryAddress.City;
                orderViewModel.store.countryCode = orderViewModel.DeliveryAddress.Country;
                orderViewModel.store.postalCode = orderViewModel.DeliveryAddress.Zip;
                orderViewModel.store.stateProvCode = orderViewModel.DeliveryAddress.State;
                orderViewModel.store.storeCountry = orderViewModel.DeliveryAddress.Country;
            } else {
                orderViewModel.store.StoreId = subwayScript.getStoreId(orderViewModel.storeData.LocationId.StoreNumber, orderViewModel.storeData.LocationId.SatelliteNumber);
                orderViewModel.store.address = orderViewModel.storeData.Address.Address1;
                orderViewModel.store.address1 = orderViewModel.storeData.Address.Address1;
                orderViewModel.store.address3 = orderViewModel.storeData.Address.Address2;
                orderViewModel.store.city = orderViewModel.storeData.Address.City;
                orderViewModel.store.countryCode = orderViewModel.storeData.Address.CountryCode;
                orderViewModel.store.id = subwayScript.getStoreId(orderViewModel.storeData.LocationId.StoreNumber, orderViewModel.storeData.LocationId.SatelliteNumber);
                orderViewModel.store.postalCode = orderViewModel.storeData.Address.PostalCode;
                orderViewModel.store.stateProvCode = orderViewModel.storeData.Address.stateProvCode;
            }
            orderViewModel.removeAndContinueMaintainCart = true;
            orderViewModel.currentOrder.cartQuantity = resultData && resultData.CartQuantity;
            orderViewModel.save();
            const data = {
                LocationId: {
                    'StoreNumber': orderViewModel.store.StoreId,
                    'SatelliteNumber': orderViewModel.store.satelliteNumber,
                    'Ordertype': orderViewModel.orderType
                },
                Address: {
                    'Address1': orderViewModel.store.address1,
                    'CountryCode': orderViewModel.store.countryCode
                }
            }
            if (isCurrentPage('locator')) {
                setUserStoreCookie(data);
            }
            setTimeout(function () {
                if (orderViewModel.isFavoriteOrder) {
                    orderViewModel.isFavoriteOrder = false;
                    orderViewModel.save();
                    window.location.href = subwayScript.navigation.getMyFavoritesUrl();
                } else if(!orderViewModel.hasOrderAhead){
                    window.location.href = subwayScript.navigation.getMenuUrl(orderViewModel.store.id);
                } else {
                    window.location.href = subwayScript.navigation.getOrderManagementUrl();
                }
                setTimeout(function () {
                    removeDancingBubble();
                }, 3000)
            }, 2000)

        }
    })
})
$('.new-checkout-btn').on('click', function () {
    if($(this).hasClass('find-location')) {
        var findLocationCtaText = $('.find-location').text();
        findLocationCtaText = findLocationCtaText
          ? findLocationCtaText.toLowerCase()
          : findLocationCtaText;
        $('#reorder-modal-close').trigger('click', true);
        handleCtaClickAnalytics(findLocationCtaText);
        return;
    }
    orderViewModel.orderType = orderViewModel.previousOrdertype;    
    orderViewModel.save();
    goToOrderManagementPage();      
})

$('#reorder-modal-close').on('click', function(event, isFindLocationClick) {
    if($(this).hasClass('location-closed-closeCta') && !isFindLocationClick) {
        handleCtaClickAnalytics('close');
    }
});

function goToOrderManagementPage() {
    window.location.href = subwayScript.navigation.getOrderManagementUrl();
}

function handleCtaClickAnalytics(ctaText) {
    analytics.pageLink(ctaText);
    analytics.storeClosePopupModal();
}

function updateMaintainCart(isEdit) {
    var currentLocationId = orderViewModel.storeData ? subwayScript.getStoreId(orderViewModel.storeData.LocationId.StoreNumber, orderViewModel.storeData.LocationId.SatelliteNumber) : null;
    var request = {
        LocationId: currentLocationId,
        FulfillmentType: orderViewModel.orderType,
        CartId: orderViewModel.currentOrder.cartId,
        LanguagePreferences: orderViewModel.LanguagePreferences,
        SiteName: $('#hdnSiteName').val()
    };
    orderViewModel.LanguagePreferences = null;
    orderViewModel.save();
    if (orderViewModel.orderType === 'delivery') {
        request.LocationId = orderViewModel.store.id
        request.StreetAddressLine1 = orderViewModel.DeliveryAddress.StreetAddressLine1
        request.StreetAddressLine2 = orderViewModel.DeliveryAddress.StreetAddressLine2
        request.City = orderViewModel.DeliveryAddress.City
        request.State = orderViewModel.DeliveryAddress.State
        request.Zip = orderViewModel.DeliveryAddress.Zip
        request.Country = orderViewModel.DeliveryAddress.Country
        request.DirectDelivery = orderViewModel.DeliveryAddress.DirectDelivery
        request.QuoteId = orderViewModel.DeliveryAddress.QuoteId
    }
    var locator = new window.FwhLocator();
    $.ajax({
        url: '/RemoteOrder/Orders/CheckoutEditAddress',
        type: 'POST',
        cache: false,
        async: false,
        headers: { "cache-control": "no-cache" },
        data: request,
        error: function (jqXhr) {
             const errorResponse = jqXhr.responseJSON && (jqXhr.responseJSON.error || jqXhr.responseJSON.Error);
            if(jqXhr.status === 400 && (errorResponse.url || errorResponse.Url)){
                crossCountryWarning(errorResponse)
                locator.asyncCallbackComplete();
                return;
            }
            subwayScript.hideSpinner();
            subwayScript.showAjaxError(jqXhr);
            locator.asyncCallbackComplete();
        },
        success: function (resultData) {
            subwayScript.hideSpinner();
            const $checkoutBtn = $('#checkout-btn');
            const $closeButton = $("#reorder-modal-close");
            
            if (resultData.storeError) {
                analytics.storeCloseModalAnalytics('location closed modal', true, resultData.storeError.createStoreErrorData)
                const $reOrderModal = $("#reOrderModal");
                const $startOrderBtn = $('#startOrder-btn');
                const errorData = resultData.storeError.createStoreErrorData;
                $closeButton.addClass('location-closed-closeCta');

                $reOrderModal.addClass('location-closed');
                $("#item-title").text(errorData.title);
                $('#maintainCartModal-body').empty().append(`<div class="item-txt" id="item-desc">${errorData.message}</div>`);

                $startOrderBtn
                    .removeClass('hide')
                    .addClass('continue')
                    .attr({
                        'data-url': errorData.url,
                        'data-testauto-id': 'continue-btn'
                    })
                    .html(errorData.buttonList[0].buttonText);

                $checkoutBtn
                    .addClass('w-100 find-location rtn-checkout-btn')
                    .removeClass('hide btn-border')
                    .attr({
                        'aria-hidden': "false",
                        'data-testauto-id': 'find-location-btn'
                    })
                    .html(errorData.buttonList[1].buttonText);

                modalShowId('#reOrderModal');
                globalUtil.modalPopupOpen('#reOrderModal');
                locator.asyncCallbackComplete();
                return;
            }
            $closeButton.removeClass('location-closed-closeCta');
            $checkoutBtn.removeClass('find-location');
            $("#reOrderModal").removeClass('location-closed');
            orderViewModel.removeAndContinueMaintainCart = false;
            orderViewModel.hasOrderAhead = resultData.HasOrderAhead;
            orderViewModel.analyticsStoreStatus = resultData.IsStoreOpen ? 'online' : 'offline' ;
            if (!resultData.SuccessResult) {
                $('#modal-head').append($('<div class="item-head-txt"></div>'))
                $("#item-title").text(resultData.Title);
                $("#item-desc").text(resultData.Description);
                $('#maintainCartModal-body').empty()
                let ingredientComboUnavailable = false;
                orderViewModel.ItemUnavailableList = resultData.ItemUnavailableList
                orderViewModel.save();
                var ingredientAndCombo = "";
                var ingredientAvailable = "";
                var comboAvailable = "";
                var isProductAvailable = false;
                var analytics_warning_message = []
                resultData.ProductData.map((item, idx) => {
                    var getDetilas = orderViewModel.analyticsCartProducts.filter((products) => products.productId == item.analytics.ProductId);
                     const category_name = item.Analytics ? item.Analytics.CategoryName :
                         getDetilas[0].categoryName;
                     const category_id = item.Analytics ? item.Analytics.CategoryId :
                         getDetilas[0].categoryId;
                    if (getDetilas.length > 0) {
                        analyticResults.push(
                            {
                                categoryName: category_name,
                                categoryId: category_id,
                                productName: filterProductName(item.Analytics.ProductName),
                                productId: item.ProductId,
                                price: item.TotalPrice,
                                quantity: item.Quantity,
                                productUnavialable: item.IsItemUnavailable,
                                itemAvailable: item.IsIngredientUnvailable || item.IsComboUnavailable,
                                options: item.Options,
                                combo: item.Combo
                            })
                    }

                    $('#maintainCartModal-body').append($('<div class="products-avaliability"></div >').append(`<div class= "prd-name" id="name-${idx}"></div><div class="prd-items" id="items-${idx}"></div>`))
                    if (item.IsItemUnavailable) {
                        $(`#name-${idx}`).append(item.ProductName);
                        $(`#items-${idx}`).append(resultData.ProductUnavailable);
                        isProductAvailable = item.IsItemUnavailable;
                        analytics_warning_message.push(resultData.ProductUnavailable)
                        if(!item.IsBundleItem){
                            orderViewModel.cartItemId.push(item.CartItemId)
                        }
                        
                        if(item.IsBundleItem){
                            orderViewModel.bundleItemId.push(item.CartItemId)
                        }
                    }
                    if (!item.IsItemUnavailable && item.IsIngredientUnvailable && item.IsComboUnavailable) {
                        var ingredients = []
                        var combos = []
                        item.Options.map(el => ingredients.push(el.OptionName))
                        item.Combo.ComboItems.map(el => combos.push(el.ProductName))
                        if (item.Combo && item.Combo.Options && item.Combo.Options.length != 0) {
                            item.Combo.Options.map(el => combos.push(el.OptionName))
                        }
                        $(`#name-${idx}`).append(item.ProductName);
                        $(`#items-${idx}`).append(resultData.ItemsUnavailable + " " + ingredients + " " + combos);
                        ingredientAndCombo = ingredientAndCombo.toString() + combos.toString();
                        analytics_warning_message.push(resultData.ItemsUnavailable + " " + ingredients + " " + combos)
                    }
                    if (!item.IsItemUnavailable && item.IsIngredientUnvailable && !item.IsComboUnavailable) {
                        var ingredients = []
                        item.Options.map(el => ingredients.push(el.OptionName))
                        $(`#name-${idx}`).append(item.ProductName);
                        $(`#items-${idx}`).append(resultData.ItemsUnavailable + " " + ingredients);
                        ingredientAvailable = ingredients.toString();
                        analytics_warning_message.push(resultData.ItemsUnavailable + " " + ingredients)
                    }

                    if (!item.IsItemUnavailable && item.IsComboUnavailable && !item.IsIngredientUnvailable) {
                        var combos = []
                        item.Combo && item.Combo.ComboItems && item.Combo.ComboItems.map(el => combos.push(el.ProductName))
                        item.Combo && item.Combo.Options && item.Combo.Options.map(el => combos.push(el.OptionName))
                        $(`#name-${idx}`).append(item.ProductName);
                        $(`#items-${idx}`).append(resultData.ItemsUnavailable + " " + combos);
                        comboAvailable = combos.toString();
                        analytics_warning_message.push(resultData.ItemsUnavailable + " " + combos)
                    }
                })
                if (resultData.IsAllItemUnavailable) {
                    orderViewModel.removeAndContinueMaintainCart = false;
                    $('#startOrder-btn').removeClass('hide')

                    $('#checkout-btn').addClass('btn-border')
                    $('#checkout-btn').addClass('w-100')
                    $('#startOrder-btn').html(resultData.StartNewOrder)
                    $('#checkout-btn').html(resultData.ReturnToBag)
                    $('#checkout-btn').removeClass('rtn-checkout-btn')
                    if (window.location.href.toLowerCase().indexOf(subwayScript.IsEdit) > 1) {
                        $('#checkout-btn').removeClass('hide')
                        $('#checkout-btn').attr('aria-hidden', "false")
                    }
                } else {
                    resultData.ProductData.forEach(function (item) {
                        if (item.IsComboUnavailable || item.IsItemUnavailable) {
                            orderViewModel.removeAndContinueMaintainCart = true;
                        }
                    })

                    $('#removeItem-btn').removeClass('hide')
                    $('#removeItem-btn').addClass('w-100')
                    $('#startOrder-btn').addClass('btn-border')
                    $('#startOrder-btn').removeClass('hide')
                    $('#removeItem-btn').html(resultData.RemoveAndContinue)
                    $('#startOrder-btn').html(resultData.StartNewOrder)
                    $('#checkout-btn').addClass('w-100')
                    $('#checkout-btn').removeClass('btn')
                    $('#checkout-btn').html(resultData.ReturnToBag)
                    
                    if (window.location.href.toLowerCase().indexOf(subwayScript.IsEdit) > 1) {
                        $('#checkout-btn').removeClass('hide')
                        $('#checkout-btn').attr('aria-hidden', "false")
                    }
                }
                orderViewModel.save();
                var errorMessage = analytics_warning_message.join('|');
                analytics.updateMaintainCart(errorMessage);
                modalShowId('#reOrderModal');
                globalUtil.modalPopupOpen('#reOrderModal');
                locator.asyncCallbackComplete();
            } else {
                if (orderViewModel.orderType === 'delivery') {
                    orderViewModel.store.StoreId = subwayScript.checkSatelliteNumber(orderViewModel.store.id);
                    orderViewModel.store.address = orderViewModel.DeliveryAddress.StreetAddressLine1;
                    orderViewModel.store.address1 = orderViewModel.DeliveryAddress.StreetAddressLine1;
                    orderViewModel.store.address3 = null;
                    orderViewModel.store.city = orderViewModel.DeliveryAddress.City;
                    orderViewModel.store.countryCode = orderViewModel.DeliveryAddress.Country;
                    orderViewModel.store.postalCode = orderViewModel.DeliveryAddress.Zip;
                    orderViewModel.store.stateProvCode = orderViewModel.DeliveryAddress.State;
                    orderViewModel.store.storeCountry = orderViewModel.DeliveryAddress.Country;
                } else {
                    orderViewModel.store.StoreId = subwayScript.getStoreId(orderViewModel.storeData.LocationId.StoreNumber, orderViewModel.storeData.LocationId.SatelliteNumber);
                    orderViewModel.store.address = orderViewModel.storeData.Address.Address1;
                    orderViewModel.store.address1 = orderViewModel.storeData.Address.Address1;
                    orderViewModel.store.address3 = orderViewModel.storeData.Address.Address2;
                    orderViewModel.store.city = orderViewModel.storeData.Address.City;
                    orderViewModel.store.countryCode = orderViewModel.storeData.Address.CountryCode;
                    orderViewModel.store.id = subwayScript.getStoreId(orderViewModel.storeData.LocationId.StoreNumber, orderViewModel.storeData.LocationId.SatelliteNumber);
                    orderViewModel.store.postalCode = orderViewModel.storeData.Address.PostalCode;
                    orderViewModel.store.stateProvCode = orderViewModel.storeData.Address.stateProvCode;
                    orderViewModel.store.storeNumber = orderViewModel.storeData.LocationId.StoreNumber
                }

                orderViewModel.save();
                const data = {
                    LocationId: {
                        'StoreNumber': orderViewModel.store.StoreId,
                        'SatelliteNumber': orderViewModel.store.satelliteNumber,
                        'Ordertype': orderViewModel.orderType
                    },
                    Address: {
                        'Address1': orderViewModel.store.address1,
                        'CountryCode': orderViewModel.store.countryCode
                    }
                }
                if (isCurrentPage('locator')) {
                    setUserStoreCookie(data);
                }

                if (orderViewModel.maintainCartAddressClick) {
                    orderViewModel.maintainCartAddressClick = false;
                    orderViewModel.save();
                    window.location.href = subwayScript.navigation.getMenuUrl(orderViewModel.store.id);
                } else if (orderViewModel.orderNowDashboardClick) {
                    orderViewModel.orderNowDashboardClick = false;
                    orderViewModel.save();
                    window.location.href = subwayScript.navigation.getMenuUrl(orderViewModel.store.id);
                } else if (orderViewModel.isFavoriteOrder) {
                    orderViewModel.isFavoriteOrder = false;
                    orderViewModel.save();
                    window.location.href = subwayScript.navigation.getMyFavoritesUrl();
                } else if (isEdit) {  
                    if(!resultData.HasOrderAhead) {
                        window.location.href = subwayScript.navigation.getMenuUrl(orderViewModel.store.id);
                    } else {               
                        goToOrderManagementPage();
                    }
                } else {
                    goToOrderManagementPage();
                }

            }
        }
    });
}
function createDeliveryCart(fromDefaultStore = false) {
    let result = false;
    var addressLine2 = fromDefaultStore ? orderViewModel.DeliveryAddress.StreetAddressLine2 : $('#optionalAddress').val();
    var createCartDetails = {
        StoreId: orderViewModel.store.id,
        StreetAddressLine1: orderViewModel.DeliveryAddress.StreetAddressLine1,
        StreetAddressLine2: addressLine2,
        City: orderViewModel.DeliveryAddress.City,
        State: orderViewModel.DeliveryAddress.State,
        Zip: orderViewModel.DeliveryAddress.Zip,
        Country: orderViewModel.DeliveryAddress.Country,
        DirectDelivery: orderViewModel.DeliveryAddress.DirectDelivery,
        QuoteId: orderViewModel.DeliveryAddress.QuoteId,
        OrderType: orderViewModel.orderType,
        IsPromoID: ShopPromotionFlag == 'true' ? getParameterByName('promoId') ? true : false : false,
        IsPromoCode: ShopPromotionFlag == 'true' ? getParameterByName('promoCode') ? true : false : false,
        Offers: [
            {
                PromoCode: getParameterByName('promoCode')
            }
        ],
        SiteName: orderViewModel.addressData.SiteName
    };
    var $frmCreateCart = $('#frmCreateCart');
    subwayScript.showSpinner();
    $.ajax({
        url: $frmCreateCart.attr('action'),
        type: 'POST',
        cache: false,
        async: false,
        headers: { "cache-control": "no-cache" },
        data: createCartDetails,
        error: function (jqXhr) {   
            if(((orderViewModel.currentOrder.cartId == null || orderViewModel.currentOrder.cartId == undefined || orderViewModel.currentOrder.cartId == '')&& orderViewModel.orderType === 'delivery')){
                return null;
            }else{
                subwayScript.hideSpinner();
                subwayScript.showAjaxError(jqXhr);
            }
        },
        success: function (resultData) {
            if (resultData.Error) {
                subwayScript.showAjaxError(resultData);
            } else if (!resultData.HasOrderType) {
                modalShowId('#orderTypeModal');
            } else if (!resultData.IsWebOrderAvailable) {
                modalShowId('#modal-web-order-not-available');
            } else if (!resultData.IsStoreOpen) {
                var title = $('#modal-store-closed').find('.error-title').text() || $('#modal-store-closed').find('.head-txt').text();
                var body = $('#modal-store-closed').find('.error-body').text() || $('#modal-store-closed').find('.body-txt').text();
                analytics.pageError(title, body, 'n/a', 'n/a', false);
                modalShowId('#modal-store-closed');
            } else {
                $('#scLanguageCode').val(resultData.AvailableStoreCultures);
                var curContext = subwayScript.navigation.getLanguageCode();
                if (curContext.indexOf(resultData.AvailableStoreCultures) === -1) {
                    redirectToLanguageContext(resultData.AvailableStoreCultures);
                }
                resultData.Store.StoreId = createCartDetails.StoreId; //Satellite Number is not getting form API, so set new store id
                subwayScript.updateStoreDetails(resultData.Store);
                orderViewModel.currentOrder.cartId = resultData.Cart.CartId;
                orderViewModel.currentOrder.cartQuantity = 0;
                orderViewModel.hasCurbside = resultData.HasCurbside;
                orderViewModel.hasCurbsideBeforeHours = resultData.HasCurbsideBeforeHours;
                orderViewModel.curbsideAvailableMessage = resultData.CurbsideAvailableMessage;
                orderViewModel.scheduleCurbsideMessage = resultData.ScheduleCurbsideMessage;
                orderViewModel.DeliveryAddress.StreetAddressLine2 = createCartDetails.StreetAddressLine2;
                orderViewModel.cartOpen = true;
                orderViewModel.promoDetails.isDealApplied = resultData.IsDealApplied;
                if (!getParameterByName('promoId')) {
                    orderViewModel.promosAndDeals.isPromoCodeApplied = false
                }
                if (resultData.IsDealApplied) {
                    orderViewModel.promosAndDeals.isPromoCodeApplied = getParameterByName('promoCode') ? true : false
                }
                orderViewModel.storeStatus = resultData.IsStoreOpen;
                orderViewModel.save();
                subwayScript.setCookie('CartId', orderViewModel.currentOrder.cartId, 90);
            }
            subwayScript.hideSpinner();
            orderViewModel.hasDeliveryLocator = true;
            orderViewModel.DeliveryAddress.DirectDelivery = orderViewModel.hasDeliveryLocator;
            orderViewModel.save();
            analytics.deliveryLocator();
            result = true;
        }
    });
    return result;
}

function onLocatorCloseFunction() {

    window.location.href = orderViewModel.targetlocator ? orderViewModel.targetlocator : subwayScript.navigation.getLanguageCode();
}
